module.exports = "/_next/static/images/88aa938fa7ae65a259dc6e15b1f78a30-sanpablo-2-desktop.jpg.webp";